module.exports = __webpack_public_path__ + "static/media/Item 18.42603f84.jpg";